
import { select } from '../../dom/modules/select.js';
import events     from '../../dom/modules/events.js';

events({ type: 'slide-active', select: '[controls="navigation"]' }, document)
.each((e) => {
    const slideshow = e.target.closest('slide-show');
    const count     = slideshow.querySelector('.count-block');
    if (!count) { return; }

    const slides    = select('slide-show > :not([slot]):not([data-slide-index])', slideshow);
    const slide     = e.target;
    count.textContent = (slides.indexOf(slide) + 1) + '/' + slides.length;
});
